export const getEntity = () => {
    return window._extra['tool-date-formatter']?.options?.entity;
};

export function formatZh(count, unit, word) {
    let result = count;
    if (count > 10000) {
        const num = Math.floor(count / 10000);
        const decimal = Math.floor((count % 10000) / 1000);
        result = decimal === 0 ? `${num}${unit}` : `${num}.${decimal}${unit}`;
    }
    return `${word} ${result}`;
}

export function formatEnJa(count, word) {
    let result = count;
    if (count > 10000) {
        const num = Math.floor(count / 1000);
        const decimal = Math.floor((count % 1000) / 100);
        result = decimal === 0 ? `${num}K` : `${num}.${decimal}K`;
    }
    return `${result} ${word}`;
}
